import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  public isLoading: boolean = true;
  public isBusy: boolean = true;
  constructor() { }

  changeLoading(str, v) {
    //console.log({ "area":str, "value":v });
    this.isLoading = v;
  }
}
